export default __webpack_public_path__ + "static/media/dimension.4111d4f2.svg";